import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c(VIcon,{attrs:{"size":this.size,"color":"grey lighten-2"}},[_vm._v(" mdi-folder-remove ")]),_c('p',{staticClass:"text-h5 grey--text"},[_vm._v("No data available")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }